import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Paper,
  Grid,
  Divider,
  CardMedia,
} from "@mui/material";
import { eventService } from "../../../services/api/eventService";
import { useAuth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify";
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';

import { Event } from "../../../types/event";


interface EventViewModalProps {
  open: boolean;
  event: Event;
  onClose: () => void;
}

const EventViewModal: React.FC<EventViewModalProps> = ({ open, event, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Event Details: {event.title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          {event.imageUrl && (
            <Grid item xs={12}>
              <Paper elevation={1} sx={{ overflow: 'hidden', borderRadius: 1, mb: 2 }}>
                <CardMedia
                  component="img"
                  image={event.imageUrl}
                  alt={event.title}
                  sx={{ 
                    width: '100%', 
                    height: 250, 
                    objectFit: 'cover',
                    objectPosition: 'center',
                  }}
                />
              </Paper>
            </Grid>
          )}
          
          {!event.imageUrl && (
            <Grid item xs={12}>
              <Paper 
                elevation={1} 
                sx={{ 
                  height: 150, 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  backgroundColor: '#f5f5f5',
                  mb: 2
                }}
              >
                <Box textAlign="center">
                  <InsertPhotoIcon sx={{ fontSize: 60, color: '#bdbdbd' }} />
                  <Typography variant="body2" color="textSecondary">
                    No image available
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          )}
          
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">Date</Typography>
            <Typography variant="body1" paragraph>{event.date}</Typography>
            
            <Typography variant="subtitle1" fontWeight="bold">Time</Typography>
            <Typography variant="body1" paragraph>{event.time}</Typography>
            
            <Typography variant="subtitle1" fontWeight="bold">Status</Typography>
            <Typography 
              variant="body1" 
              paragraph
              sx={{
                textTransform: 'capitalize',
                color: 
                  event.status === 'upcoming' ? 'primary.main' : 
                  event.status === 'completed' ? 'success.main' : 
                  'error.main'
              }}
            >
              {event.status}
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">Location</Typography>
            <Typography variant="body1" paragraph>{event.location}</Typography>
            
            <Typography variant="subtitle1" fontWeight="bold">Organizer</Typography>
            <Typography variant="body1" paragraph>{event.organizer}</Typography>
          </Grid>
          
          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle1" fontWeight="bold">Description</Typography>
            <Typography variant="body1" paragraph>
              {event.description || "No description available."}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EventViewModal;
